module.exports = __webpack_public_path__ + "img/1024.dda6f012.jpg";